"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KiloFormatter = function (_a) {
    var value = _a.value;
    return (Math.abs(value) > 999 ? Math.sign(value) * Math.round(Math.abs(value) / 100) / 10 + 'K' : Math.sign(value) * Math.abs(value)).toString();
};
exports.default = KiloFormatter;
